import { appConfig } from 'config/appConfig';
import { dayjsConfig } from 'config/dayjsConfig';
import { i18nConfig } from 'config/i18nConfig';
import { messageConfig } from 'config/messageConfig';

export const configure = async () => {
  appConfig();
  dayjsConfig();
  messageConfig();
  await i18nConfig();
};
